export default "__VITE_ASSET__r18nlNrB__"